import React from "react";
import { withAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import {
  PageWrapper,
  MainWrapper,
  HeadingWrapper,
  MainViewWrapper,
  ListItemWrapper,
  ProfileImageWrapper,
  ButtonsWrapper,
  MainHeading,
  HeadingText,
  IndicatorWrapper,
  IconStyled,
  ButtonStyled,
  ProfileName,
  ProfileImage,
  ProfileImageContainer,
  MainViewContainer,
  LogoStyled,
  InstructionText
} from "./styles/Styled";
import ItemSelector from "../../components/MultipleProfiles/EditProfile/ItemSelector/ItemSelector";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import { i18n } from "../../services/i18nService";
import {
  showProfileImagesModal,
  showSaveProfileChangesModal,
  showMultiProfileLanguageModal,
  showProfileLockModal,
  showDeleteProfileModal
} from "../../utils/multiProfileModalUtils";
import { generatePin } from "../../services/pinLoginService";
import FreeLogo from "../../components/FreeLogo";
import {
  getProfileAvatars,
  onEditProfile,
  onDeleteProfile,
  getCurrentProfile
} from "../../services/multipleProfilesService";
import { routes } from "../../routes/routes";
import getRemoteKey from "../../services/remoteService";
import { getLanguagesList } from "../../pages/Settings/Settings";
import { config } from "../../config/config";
import { onChangeUserLanguage, detectActiveLanguage } from "../../utils/multipleProfilesUtils";
import { redirectTo } from "../../services/navigationService";
import { historyMethods } from "../../utils/historyMethods";
import { showMultipleProfileErrorModal } from "../../services/modalsService";
import { trackEvent } from "../../services/analyticsService";

export const ICONS = { ltr: "arrow_profile_right", rtl: "arrow_profile_right" };

const Button = withFocusable(ButtonStyled);

const MP = "MP";
export const PROFILE_IMAGE = "profileImage";
export const PROFILE_NAME = "profileName";
export const DISPLAY_LANGUAGE = "displayLanguage";
export const PROFILE_LOCK = "profileLock";
export const VIEWING_RESTRICTIONS = "viewingRestrictions";
export const KIDS_PROFILE = "kidsProfile";

export const i18nLanguageList = list => {
  list.forEach(item => {
    item.title = i18n.get(`global.editProfile.languages.${item.languageCode}`);
  });
  return list;
};
let previousFocus = null;
class EditProfile extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      profileImage: {
        avatars: [],
        currentAvatar: "",
        selectedAvatar: ""
      },
      pinResponse: "",
      isLoading: false,
      profileName: "",
      selectedLanguage: getLanguagesList(config.get().locales)[0],
      languageList: i18nLanguageList(getLanguagesList(config.get().locales)),
      profileId: "",
      isMasterProfile: false,
      items: [
        {
          key: PROFILE_IMAGE,
          title: i18n.get("global.editProfile.profileImageCta"),
          description: "",
          disabled: false,
          visible: true
        },
        {
          key: PROFILE_NAME,
          title: i18n.get("global.editProfile.profileNameCta"),
          description: "",
          disabled: false,
          visible: true
        },
        {
          key: DISPLAY_LANGUAGE,
          title: i18n.get("global.editProfile.displayLangCta"),
          description: "English",
          disabled: false,
          visible: true
        }
      ],
      profileData: null, // profile data from previous page - Use for back navigation - don't delete that
      isUserChangeAnything: false,
      oldProfileData: null
    };
    this.currentProfile = null;
    this.isSaveChangesModalOpen = false;
    this.onClickDeleteProfileBtn = this.onClickDeleteProfileBtn.bind(this);
    this.getSelectedAvatar = this.getSelectedAvatar.bind(this);
    this.onClickProfileName = this.onClickProfileName.bind(this);
    this.setAllProfileAvatars = this.setAllProfileAvatars.bind(this);
    this.onChangeProfileLanguage = this.onChangeProfileLanguage.bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
    this.onDiscardChanges = this.onDiscardChanges.bind(this);
    this.onBack = this.onBack.bind(this);
    this.onKeepProfile = this.onKeepProfile.bind(this);
    this.onDeleteProfile = this.onDeleteProfile.bind(this);
    this.showDeleteProfilePopup = this.showDeleteProfilePopup.bind(this);
    this.onUpEditProfileList = this.onUpEditProfileList.bind(this);
    this.setOldProfileData = this.setOldProfileData.bind(this);
    this.isUserChangeAnythingActually = this.isUserChangeAnythingActually.bind(this);
  }

  async componentDidMount() {
    const { onRef } = this.props;
    onRef && onRef(this);
    document.addEventListener("keydown", this.keydownHandler);
    this.props.setFocus(previousFocus);
    try {
      this.currentProfile = await getCurrentProfile();
      await this.setAllProfileAvatars();
      await this.setProfileData();
      await this.setOldProfileData();
      await this.showDeleteProfilePopup();
    } catch (error) {
      // // console.log("==> ~ EditProfile ~ componentDidMount ~ error:", error);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keydownHandler);
  }

  keydownHandler = e => {
    const pressedKey = getRemoteKey(e.keyCode);
    const {
      applicationState: { currentFocus },
      setFocus
    } = this.props;
    if (pressedKey === "ARROW_UP") {
      setTimeout(() => {
        if (currentFocus === "save_passThru" || currentFocus === "delete_passThru") {
          setFocus(`@selectorItem_2_editProfile`);
        }
      }, 1); // Need setTimOut to avoid focus issue
    }
    if (!this.props.applicationState.globalModal) {
      setFocus(previousFocus);
      previousFocus = null;
    }
  };

  async onSaveChanges() {
    const { profileId, profileName, profileImage, profileData, selectedLanguage, oldProfileData } = this.state;
    const data = {
      profileId: profileId,
      profileName: profileName,
      avatar: profileImage.currentAvatar,
      language: selectedLanguage.languageCode || selectedLanguage.key,
      profileCategory: profileData.profileCategory,
      isMasterProfile: profileData.isMasterProfile
    };

    if (oldProfileData.profileName === profileName) {
      delete data.profileName;
    }

    try {
      const updatedProfileData = await onEditProfile.call(this, data);
      const updatedProfile = {
        location: this.isSaveChangesModalOpen ? "back discard popup" : "manage profile screen",
        isAvatarChange: !!(profileImage.currentAvatar !== oldProfileData.avatar),
        isProfileNameChange: !!(oldProfileData?.profileName !== profileName)
      };
      trackEvent("profile_settings_updated", null, MP, {
        profileData: { updatedProfileId: updatedProfileData?.profileId, ...updatedProfileData },
        updatedProfile
      });
      this.isSaveChangesModalOpen = false;
      this.props.stateActions.hideGlobalModal();
      this.props.history.replace({
        pathname: routes.profileSelector
      });
    } catch (e) {
      showMultipleProfileErrorModal.call(this, "save_passThru");
    }
  }

  onDiscardChanges() {
    const { stateActions, history } = this.props;
    const { profileData } = this.state;
    trackEvent("profile_settings_update_discarded", null, MP, { location: "back discard popup", ...profileData });
    this.setState({}); // Reset state
    this.isSaveChangesModalOpen = false;
    stateActions.hideGlobalModal();
    history.replace({
      pathname: routes.profileSelector
    });
  }

  async onClickDeleteProfileBtn() {
    previousFocus = this.props.applicationState.currentFocus;
    const { selectedLanguage } = this.state;
    redirectTo.call(
      this,
      routes.accountPassword,
      {
        backDestination: routes.editProfile,
        profileId: this.state.profileId,
        profileName: this.state.profileName,
        avatar: this.state.profileImage.currentAvatar,
        profileData: {
          ...this.state.profileData,
          avatar: this.state.profileImage.currentAvatar,
          profileName: this.state.profileName,
          language: selectedLanguage.languageCode || selectedLanguage.key
        },
        oldProfileData: this.state.oldProfileData
      },
      historyMethods.PUSH
    );
  }

  onKeepProfile() {
    trackEvent("profile_delete_keep_clicked", null, MP, this.state.profileData);
    this.props.stateActions.hideGlobalModal();
  }

  async showDeleteProfilePopup() {
    const { location } = this.props;
    const hasHistoryState = !!(location && location.state);
    const isPasswordVerified = location.state.isPasswordVerified;
    if (hasHistoryState && isPasswordVerified) {
      await showDeleteProfileModal.call(this, this.onKeepProfile, this.onDeleteProfile);
    }
  }

  async onDeleteProfile() {
    const { location } = this.props;
    const hasHistoryState = !!(location && location.state);
    const accountPassword = location.state.accountPassword;
    if (hasHistoryState && accountPassword) {
      const data = {
        profileId: this.state.profileId,
        password: accountPassword
      };
      try {
        const response = await onDeleteProfile(data);
        if (response === 200) {
          trackEvent("profile_deleted", null, MP, {
            updatedProfileId: this.state.profileId,
            ...this.state.profileData
          });
          this.props.stateActions.hideGlobalModal();
          this.props.history.replace({
            pathname: routes.profileSelector
          });
        }
      } catch (e) {
        console.log("==> ~ EditProfile ~ onSaveChanges ~ e:", e);
        showMultipleProfileErrorModal.call(this, "delete_passThru");
      }
    }
  }

  async getSelectedAvatar(selectedAvatar) {
    this.setState(
      {
        profileImage: {
          ...this.state.profileImage,
          currentAvatar: selectedAvatar
        }
      },
      () => {
        this.isUserChangeAnythingActually();
      }
    );
    this.props.stateActions.hideGlobalModal();
  }

  async setAllProfileAvatars() {
    const avatars = await getProfileAvatars();
    let avatarsWithFocusPath = avatars.map((item, index) => ({ src: item, focusPath: `selectedImage_${index}` }));
    this.setState({
      profileImage: {
        ...this.state.profileImage,
        avatars: avatarsWithFocusPath
      }
    });
  }

  async setProfileData() {
    const { location } = this.props;

    const hasHistoryState = !!(location && location.state);
    const profileData = location.state.profileData;
    const profileName = location.state.profileName;
    if (hasHistoryState && profileData) {
      this.setState({
        profileImage: {
          ...this.state.profileImage,
          currentAvatar: profileData.avatar,
          selectedAvatar: profileData.avatar
        },
        profileName: profileName || profileData.profileName,
        language: profileData.language,
        profileId: profileData.profileId,
        isMasterProfile: profileData.isMasterProfile,
        profileData: profileData
      });
      this.setUserProfileLanguage(profileData.language);
    }
  }

  async setOldProfileData() {
    const { location } = this.props;

    const hasHistoryState = !!(location && location.state);
    const oldProfileData = location.state.oldProfileData;
    if (hasHistoryState && oldProfileData) {
      this.setState(
        {
          oldProfileData: oldProfileData
        },
        () => {
          this.isUserChangeAnythingActually();
        }
      );
    }
  }

  isUserChangeAnythingActually() {
    const { oldProfileData, profileImage, selectedLanguage, profileName } = this.state;
    if (oldProfileData) {
      if (
        oldProfileData?.profileName !== profileName ||
        oldProfileData?.avatar !== profileImage?.currentAvatar ||
        oldProfileData?.language !== selectedLanguage?.languageCode
      ) {
        this.setState({
          isUserChangeAnything: true
        });
      } else if (
        oldProfileData?.avatar === profileImage?.currentAvatar &&
        oldProfileData?.language === selectedLanguage?.languageCode &&
        oldProfileData?.profileName === profileName
      ) {
        this.setState({
          isUserChangeAnything: false
        });
      }
    }
  }

  onClickProfileName() {
    const profileData = {
      ...this.state.profileData,
      profileName: this.state.profileName,
      avatar: this.state.profileImage.currentAvatar,
      language: this.state.selectedLanguage.languageCode
    };
    this.props.history.push({
      pathname: routes.profileName,
      state: {
        backDestination: routes.editProfile,
        profileName: this.state.profileName,
        avatar: this.state.profileImage.currentAvatar,
        profileData: profileData,
        oldProfileData: this.state.oldProfileData
      }
    });
  }

  onChangeProfileLanguage(selectedLangDetail) {
    const { items } = this.state;
    items.forEach(item => {
      if (item.key === DISPLAY_LANGUAGE) {
        item.description = selectedLangDetail.title;
      }
    });
    const langs = getLanguagesList(config.get().locales);
    let languageList = [...langs];
    const languageListWithActiveLang = detectActiveLanguage(languageList, selectedLangDetail);
    this.setState({
      items: items,
      selectedLanguage: selectedLangDetail,
      languageList: languageListWithActiveLang
    });
    this.isUserChangeAnythingActually();
  }

  setUserProfileLanguage(key) {
    const langs = getLanguagesList(config.get().locales);
    const selectedLangDetail = langs.find(lang => lang.languageCode === key);
    this.onChangeProfileLanguage(selectedLangDetail);
  }

  async showMultiProfileLanguageModal() {
    const { languageList, selectedLanguage } = this.state;
    await showMultiProfileLanguageModal.call(this, languageList, selectedLanguage);
  }

  async onChangeLanguage(selectedLanguage, availableLanguages) {
    onChangeUserLanguage.call(this, selectedLanguage, availableLanguages, previousFocus);
    this.isUserChangeAnythingActually();
  }

  async showProfileLockPinModal() {
    this.setState({
      ...this.state,
      isLoading: true
    });

    this.setState({
      ...this.state,
      pinResponse: await generatePin(),
      isLoading: false
    });
    await showProfileLockModal.call(this, this.state.pinResponse, this.isLoaded);
  }

  onBack() {
    if (this.state.isUserChangeAnything) {
      this.isSaveChangesModalOpen = true;
      return showSaveProfileChangesModal.call(this, this.onSaveChanges, this.onDiscardChanges);
    }
    redirectTo.call(this, routes.profileSelector, null, historyMethods.REPLACE);
    return true;
  }
  onUpEditProfileList(index, focusName) {
    if (index === 0) {
      this.props.setFocus(`selectorItem_${index}_${focusName}`);
    } else {
      this.props.setFocus(`selectorItem_${index - 1}_${focusName}`);
    }
  }

  render() {
    const {
      stateActions,
      setFocus,
      pauseNavigation,
      resumeNavigation,
      applicationState: { globalModal, currentFocus }
    } = this.props;
    const { items, profileData } = this.state;
    return (
      <>
        {this.state.isLoading && <Loading overlay />}
        <PageWrapper>
          <LogoStyled>
            <FreeLogo height={"1.968rem"} />
          </LogoStyled>
          <MainWrapper>
            <HeadingWrapper>
              <MainHeading>
                {" "}
                {i18n.get("global.welcome")} {this.state.profileName}!
              </MainHeading>
              <HeadingText>{i18n.get("pages.editProfile.subText")}</HeadingText>
            </HeadingWrapper>
            <MainViewWrapper>
              <MainViewContainer>
                <ListItemWrapper>
                  <ItemSelector
                    items={items}
                    stateActions={stateActions}
                    setFocus={setFocus}
                    pauseNavigation={pauseNavigation}
                    resumeNavigation={resumeNavigation}
                    globalModal={globalModal}
                    currentFocus={currentFocus}
                    selectedIndex={0}
                    focusName={"editProfile"}
                    onItemSelected={item => {
                      previousFocus = this.props.applicationState.currentFocus;
                      if (item.key === PROFILE_IMAGE) {
                        trackEvent("avatar_setting_clicked", null, MP, profileData);
                        showProfileImagesModal.call(this);
                      }
                      if (item.key === PROFILE_NAME) {
                        trackEvent("profile_name_setting_clicked", null, MP, profileData);
                        this.onClickProfileName(item);
                      }
                      if (item.key === DISPLAY_LANGUAGE) {
                        trackEvent("language_setting_clicked", null, MP, profileData);
                        this.showMultiProfileLanguageModal();
                      }
                      if (item.key === PROFILE_LOCK) {
                        trackEvent("profile_lock_setting_clicked", null, MP, profileData);
                        this.showProfileLockPinModal();
                      }
                    }}
                    profileImage={this.state.profileImage}
                    onChangeProfileLanguage={this.onChangeProfileLanguage}
                    profileLanguage={this.state.selectedLanguage}
                    onUp={this.onUpEditProfileList}
                  />
                  <IndicatorWrapper>
                    <IconStyled name="info" iconHeight={"2rem"} iconWidth={"2rem"} />
                    <InstructionText>{i18n.get("pages.editProfile.subText1")}</InstructionText>
                  </IndicatorWrapper>
                </ListItemWrapper>
                <ProfileImageWrapper>
                  {" "}
                  <ProfileImageContainer>
                    <ProfileImage src={this.state.profileImage.currentAvatar} />{" "}
                  </ProfileImageContainer>
                  <ProfileName>{this.state.profileName}</ProfileName>
                </ProfileImageWrapper>
              </MainViewContainer>
            </MainViewWrapper>
            <ButtonsWrapper direction={i18n.getDirection()}>
              <Button
                label={i18n.get("global.editProfile.saveProfileCta").toUpperCase()}
                focusPath="save_passThru"
                onEnterPress={() => this.onSaveChanges()}
                onMouseUp={() => this.onSaveChanges()}
                size="small"
                spacing="small"
                displayBlock={true}
                onRef={ref => (this.confirmModalFocusPath = ref)}
                dataSnDown={""}
                dataSnUp={`@selectorItem_${items.length - 1}_editProfile`}
                dataSnLeft={""}
                dataSnRight={"@delete_passThru"}
                disabled={!this.state.isUserChangeAnything}
              />
              {!this.state.isMasterProfile && (
                <Button
                  label={i18n.get("pages.editProfile.deleteProfileCta").toUpperCase()}
                  focusPath="delete_passThru"
                  onEnterPress={this.onClickDeleteProfileBtn}
                  onMouseUp={this.onClickDeleteProfileBtn}
                  size="small"
                  spacing="small"
                  displayBlock={true}
                  onRef={ref => (this.confirmModalFocusPath = ref)}
                  dataSnDown={""}
                  dataSnUp={`@selectorItem_${items.length - 1}_editProfile`}
                  dataSnLeft={"@save_passThru"}
                />
              )}
            </ButtonsWrapper>
          </MainWrapper>
        </PageWrapper>
      </>
    );
  }
}

const Component = withAppState(withSubtheme(EditProfile));

export default Component;
